// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import {
  GetAllInstrumentConfigurationsResponse,
  InstrumentConfiguration,
} from '@digitalasset/utility-operator-api-ts-client';

export const configsByContractId = (data?: GetAllInstrumentConfigurationsResponse) => {
  const res = {} as { [key: string]: InstrumentConfiguration };
  data?.instrumentConfigurations.forEach((config) => {
    res[config.contract.contractId] = config;
  });
  return res;
};
